<template>
  <div class="empty-box">
    <img :src="emptyImg" alt="">
    <p>{{text}}</p>
    <slot name="content"></slot>
  </div>
</template>

<script>
  import EmptyImg from "@/common/images/teacher/img_empty.png"
  export default {
    name: 'teacher-empty',
    props:{
      emptyImg: {
        type: String,
        default: EmptyImg
      },
      text:{
        type: String,
        default: ''
      }
    },
    data() {
      return {

      }
    }
  }
</script>

<style scoped lang="less">
.empty-box{
  min-height: 600px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #FFFFFF;
  border-radius: 12px;
  justify-content: center;
  img{
    width: 180px;
    height: 180px;
  }
  p{
    color: #000000;
    font-size: 18px;
    margin-top: 16px;
    font-weight: 600;
  }
}
</style>